import React from "react";
import CarouselCard from "./CarouselCard";

const Carousel = ({ CarouselTitle, CarouselCardList, breakPoint, bgColor }) => {
  return (
    <div
      className={`${
        bgColor === "primary"
          ? "bg-primary text-black"
          : "bg-black text-primary"
      } h-auto  py-6 w-screen   max-w-screen-2xl mx-auto  `}
    >
      <section
        className={
          " text-3xl sm:text-5xl xl:text-8xl  max-w-screen-2xl mx-auto font-bold  pb-4 h-1/5 flex   "
        }
      >
        <h1 className="mx-auto">{CarouselTitle}</h1>
      </section>
      <section
        className={` h-auto w-screen  lg:max-w-[1400px] lg:mx-auto overflow-auto flex  ${breakPoint}`}
      >
        {CarouselCardList.map((cardInfo, index) => (
          <CarouselCard
            key={index}
            bgColor={bgColor}
            id={cardInfo.id}
            img={cardInfo.img}
            alt={cardInfo.alt}
            title={cardInfo.title}
            info={cardInfo.info}
            link={cardInfo.link}
            //for about us only----
            name={cardInfo.name}
            personsTitle={cardInfo.personsTitle}
            email={cardInfo.email}
            phone={cardInfo.phone}
            // for about us only^^^
          />
        ))}
      </section>
    </div>
  );
};

export default Carousel;
